import { render, staticRenderFns } from "./MaterialEdit.vue?vue&type=template&id=a6755fc4&"
import script from "./MaterialEdit.vue?vue&type=script&lang=js&"
export * from "./MaterialEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports